<template>
  <el-collapse v-model="activeNames" style="width: 100%">
    <div class="padding12">
      <cx-slider
        label=""
        :value.sync="titleType"
        :options="titleTypeOptions"
        :showToolTip="false"
      />
    </div>
    <template v-if="titleType === '1'">
      <el-collapse-item title="位置" name="1">
        <div class="verticallyCenter">
          <div class="verticallyCenter mr12 flex1">
            <span class="fs14 mr8">横</span>
            <single-input
              :value.sync="originLeft"
              :valueType.sync="leftType"
              :showValueType="true"
              inputSuffixs="px"
              :max="300"
              :min="0"
            />
          </div>
          <div class="verticallyCenter flex1">
            <span class="fs14 mr8">纵</span>
            <single-input
              :value.sync="originTop"
              :valueType.sync="topType"
              :showValueType="true"
              inputSuffixs="px"
              :max="300"
              :min="0"
            />
          </div>
          <div :class="[isQuickSite ? 'open' : '', 'verticallyCenter quick-set-switch']">
            <el-tooltip
              class="item"
              effect="dark"
              :content="isQuickSite ? '取消定位' : '开启定位'"
              placement="top"
              :open-delay="1000"
            >
              <span class="icon icon-portal-add2" @click="changeQuickSite"></span>
            </el-tooltip>
          </div>
        </div>
        <rect-position-Set
          v-if="isQuickSite"
          :left.sync="originLeft"
          :top.sync="originTop"
          :margin.sync="margin"
          :offset.sync="offset"
          :leftType="leftType"
          :topType="topType"
        ></rect-position-Set>
      </el-collapse-item>
      <el-collapse-item title="尺寸" name="2">
        <div class="verticallyCenter">
            <div class="verticallyCenter mr16 flex1">
              <span class="fs14 mr8">宽</span>
              <single-input
                class="input-size"
                placeholder="-"
                :value.sync="originWidth"
                :valueType.sync="widthType"
                :showValueType="true"
                :min="1"
              />
            </div>
            <div class="verticallyCenter flex1">
              <span class="fs14 mr8">高</span>
              <single-input
                class="input-size"
                placeholder="-"
                :value.sync="originHeight"
                :valueType.sync="heightType"
                :showValueType="true"
                :min="1"
              />
            </div>
          </div>
      </el-collapse-item>
      <!-- <widthAndHeightSize
        :widthVal.sync="width"
        :heightVal.sync="height"
        :disableWidthAuto="true"
        :disableHeightAuto="true"
        :disableWidthFull="false"
        :disableHeightFull="false"
        :widthAuto="false"
        :heightAuto="false"
        :widthFull.sync="widthFull"
        :heightFull.sync="heightFull"
      /> -->
      <el-collapse-item title="文字" name="3">
        <text-setting-complex-update
          :fontFamily.sync="fontFamily"
          :fontSize.sync="fontSize"
          :fontWeight.sync="fontWeight"
          :fontStyle.sync="fontStyle"
          :textDecoration.sync="textDecoration"
          :lineHeight.sync="lineHeight"
          :letterSpacing.sync="letterSpacing"
          :activeArrangement.sync="activeArrangement"
          :writingMode.sync="writingMode"
          :textAlign.sync="textAlign"
          :showTextAlignSetting="true"
          :hideHighLevelSetting="true"
          :activeArrangementOrder.sync="activeArrangementOrder"
          :lineHeightType.sync="lineHeightType"
          :letterSpacingType.sync="letterSpacingType"
          :isThemeColor.sync="textIsThemeColor"
          :colorArr.sync="colorArr"
          :activeNameColor.sync="activeNameColor"
          :showOverflowSetting="true"
          :contentHasLimit.sync="contentHasLimit"
          :contentHasLimitRadio="'字数'"
          :textLimitWords.sync="textLimitLines"
          :overflowTypes="['字数', '无']"
          :options="getOptions"
        />
      </el-collapse-item>
      <el-collapse-item title="背景" name="4">
        <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" :options="getOptions" />
      </el-collapse-item>
      <el-collapse-item title="图标" name="3">
        <div class="content-item verticallyCenter">
          <el-checkbox v-model="showIcon">显示图标</el-checkbox>
        </div>
        <div v-if="showIcon" class="content-item mt8">
          <img-icon-upload
            class="mb16"
            :imgSrc.sync="iconSrc"
            :iconType.sync="iconType"
            :iconColor.sync="iconColor"
            :resInfo.sync="resInfo"
          />
          <div v-show="iconSrc.length" class="content-item mb16 verticallyCenter">
            <span class="mr16 fs14">位置</span>
            <el-radio-group v-model="iconPosition">
              <el-radio label="left">左</el-radio>
              <el-radio label="right">右</el-radio>
              <el-radio label="top">上</el-radio>
              <el-radio label="bottom">下</el-radio>
            </el-radio-group>
          </div>
          <div class="verticallyCenter mb16" v-if="iconType === 'icon'">
            <span class="mr16 fs14">颜色</span>
            <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor">
            </cx-color-picker>
          </div>

          <slider-and-input class="mb16" :value.sync="iconWidth" title="大小" :sliderMax="sliderMax" suffix="px" />
          <slider-and-input :value.sync="iconMargin" title="间距" :sliderMax="sliderMax" suffix="px" />
        </div>
      </el-collapse-item>
      <el-collapse-item title="边框" name="4">
        <div>
          <div class="content-item verticallyCenter mb8">
            <el-checkbox v-model="showBorder">显示边框</el-checkbox>
          </div>
          <cx-border
            v-if="showBorder"
            :borderWidth.sync="borderWidth"
            :borderStyle.sync="borderStyle"
            :borderColor.sync="borderColor"
            :borderIsThemeColor.sync="borderIsThemeColor"
          />
        </div>
        <div class="content-item mt12">
          <border-radius
            :borderTypeFlag.sync="borderTypeFlag"
            :borderRadius.sync="borderRadius"
            :borderTopLeftRadius.sync="borderTopLeftRadius"
            :borderTopRightRadius.sync="borderTopRightRadius"
            :borderBottomRightRadius.sync="borderBottomRightRadius"
            :borderBottomLeftRadius.sync="borderBottomLeftRadius"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item title="边距" name="5">
        <div class="setting-item">
          <div class="content">
            <div class="content-item">
              <cx-padding
                :paddingTypeFlag.sync="paddingTypeFlag"
                :padding.sync="padding"
                :paddingTop.sync="paddingTop"
                :paddingRight.sync="paddingRight"
                :paddingBottom.sync="paddingBottom"
                :paddingLeft.sync="paddingLeft"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="更多" name="6">
        <div class="setting-item">
          <div class="content">
            <div class="content-item mb16">
              <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
            </div>
            <div class="content-item mt12">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span
                  v-show="borderShadowChecked"
                  class="icon-portal-plus theme-color right-icon"
                  @click="addBoxshadow"
                ></span>
              </div>
              <box-shadow
                v-show="borderShadowChecked"
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              ></box-shadow>
            </div>
            <div class="content-item mt12 flex">
              <span class="flex1">鼠标指针</span>
              <div class="setting-item flex1">
                <div class="content">
                  <cx-cursor :cursorType.sync="cursorType" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item v-show="$store.state.states.showPluginSetting"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')" title="插件" name="8">
        <div class="setting-item">
          <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
        </div>
      </el-collapse-item>
    </template>
    <template v-if="titleType === '2'">
      <el-collapse-item title="内容" name="1">
        <div class="setting-item">
          <div class="content">
            <div class="content-item verticallyCenter">
              <div
                class="edit-div"
                contenteditable="true"
                v-html="content"
                @blur="content = $event.target.innerHTML"
              ></div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </template>
  </el-collapse>
</template>

<script>
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import rowColLayoutSize from "publicSetting/rowColLayoutSize"
import widthAndHeightSize from "publicSetting/widthAndHeightSize"
import { withMethodsHistoryCombine } from "utils/revork"
import CustomSubMenuSetting from "../render/customSubMenus/setting"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import rectPositionSet from "publicSetting/rect-position-set"
export default withMethodsHistoryCombine({
  name: "button-set",
  components: { elementPluginSetting, rowColLayoutSize, widthAndHeightSize, CustomSubMenuSetting, controlWidthAndSizeAndZindex, rectPositionSet },
  props: { 
    options: Object,
    buttonType: String
  },
  data() {
    return {
      this1: this,
      explainDialog: false,
      explainImgSrc: require("../../../assets/images/tipsVideoImg/filter-tips.png"),
      activeNames: ["1", "2", "3", "4", "5"],
      collapseActiveNames: ["1", "2"],
      allCollapseNames: ["1", "2", "3", "4", "5"],
      sliderMax: 100,
      autoWidth: "0", //是否固定宽度
      activeStatus: "status0",
      isInAutoLayout: false,
      curFilter: 0,
      activeTypeOptions: [
        { value: "1", title: "默认" },
        { value: "3", title: "选中" }
      ],
      subActiveTypeOptions: [
        { value: "1", title: "默认" },
        { value: "2", title: "悬浮" },
        { value: "3", title: "选中" }
      ],
      activeType: "1",
      subActiveType: "1",
      defaultImg: require("../../../assets/images/default_image_home.png"),
      currentSetStyle: "",
      currentSetMenu: "",
      filterTypeOptions: [
        { value: "1", title: "单选" },
        { value: "2", title: "多选" },
      ],
      overflowTypes1: ['字数', '无'],
      overflowTypes2: ['行数', '字数', '无'],
      titleType: "1",
      titleTypeOptions: [
        { value: "1", title: "样式" },
        { value: "2", title: "数据" }
      ],
      borderShadowChecked: true,
      width: 0,
      height: 0,
      left: 0,
      top: 0,
    }
  },
  watch: {
    originWidth(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.width = newVal
      }
    },
    originHeight(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.height = newVal
      }
    },
    originLeft(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.left = newVal
      }
    },
    originTop(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.top = newVal
      }
    },
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getOptions() {
      return this.options[this.buttonType] || {}
    },
    isQuickSite: {
      get() {
        if (this.getOptions.hasOwnProperty("isQuickSite")) {
          return this.getOptions.isQuickSite
        }
        return false
      },
      set(newVal) {
        if (newVal) {
          // 开启快捷定位之后，定位到第一个
          this.originLeft = 0
          this.originTop = 0
          this.leftType = "%"
          this.topType = "%"
        } else {
          let curRect = document.getElementsByClassName(this.buttonType)
          let curRectParent = curRect[0]?.parentNode
          if (curRect[0] && curRectParent) {
            // 关闭快捷定位后，将百分比换算为px
            this.leftType = "px"
            this.topType = "px"
            let rectSite = curRect[0].getBoundingClientRect()
            let parentRectSite = curRectParent.getBoundingClientRect()
            this.originLeft = parseInt(rectSite.left - parentRectSite.left)
            this.originTop = parseInt(rectSite.top - parentRectSite.top)
          }
        }
        this.changeOptions(newVal, "isQuickSite", false)
      }
    },
    pluginName: {
      get() {
        return this.getOptions.hasOwnProperty("pluginName") ? this.getOptions.pluginName : []
      },
      set(newVal) {
        this.changeOptions(newVal, "pluginName", false)
      }
    },
    // width: {
    //   get() {
    //     return this.getOptions.hasOwnProperty("width") ? this.getOptions.width : 100
    //   },
    //   set(newVal) {
    //     this.changeOptions(newVal, "width", false)
    //   }
    // },
    // height: {
    //   get() {
    //     return this.getOptions.hasOwnProperty("height") ? this.getOptions.height : 50
    //   },
    //   set(newVal) {
    //     this.changeOptions(newVal, "height", false)
    //   }
    // },
    margin: {
      get() {
        return this.getOptions.margin
      },
      set(newVal) {
        if (newVal) {
          this.topType = "%"
          this.leftType = "%"
        }
        this.changeOptions(newVal, "margin", false)
      }
    },
    offset: {
      get() {
        return this.getOptions.offset
      },
      set(newVal) {
        this.changeOptions(newVal, "offset", false)
      }
    },
    widthType: {
      get() {
        return this.getOptions.widthType || "px"
      },
      set(newVal) {
        this.changeOptions(newVal, "widthType", false)
      }
    },
    heightType: {
      get() {
        return this.getOptions.heightType || "px"
      },
      set(newVal) {
        this.changeOptions(newVal, "heightType", false)
      }
    },
    originWidth: {
      get() {
        return this.getOptions.width || 200
      },
      set(newVal) {
        newVal = newVal < 1 ? 1 : newVal
        this.changeOptions(newVal, "width", false)
      }
    },
    originHeight: {
      get() {
        return this.getOptions.height || 50
      },
      set(newVal) {
        newVal = newVal < 1 ? 1 : newVal
        this.changeOptions(newVal, "height", false)
      }
    },
    originLeft: {
      get() {
        return this.getOptions.left || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "left", false)
      }
    },
    originTop: {
      get() {
        return this.getOptions.top || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "top", false)
      }
    },
    leftType: {
      get() {
        return this.getOptions.leftType || "px"
      },
      set(newVal) {
        this.changeOptions(newVal, "leftType", false)
      }
    },
    topType: {
      get() {
        return this.getOptions.topType || "px"
      },
      set(newVal) {
        this.changeOptions(newVal, "topType", false)
      }
    },
    widthFull: {
      get() {
        return this.getOptions.hasOwnProperty("widthFull") ? this.getOptions.widthFull : false
      },
      set(newVal) {
        this.changeOptions(newVal, "widthFull", false)
      }
    },
    heightFull: {
      get() {
        return this.getOptions.hasOwnProperty("heightFull") ? this.getOptions.heightFull : false
      },
      set(newVal) {
        this.changeOptions(newVal, "heightFull", false)
      }
    },
    fontSize: {
      get() {
        return this.getOptions.fontSize || 16
      },
      set(newVal) {
        this.changeOptions(newVal, "fontSize", false)
      }
    },
    fontFamily: {
      get() {
        return this.getOptions.fontFamily || "sans-serif"
      },
      set(newVal) {
        this.changeOptions(newVal, "fontFamily", false)
      }
    },
    fontStyle: {
      get() {
        return this.getOptions.fontStyle || "normal"
      },
      set(newVal) {
        this.changeOptions(newVal, "fontStyle", false)
      }
    },
    fontWeight: {
      get() {
        return this.getOptions.fontWeight || 400
      },
      set(newVal) {
        this.changeOptions(newVal, "fontWeight", false)
      }
    },
    lineHeight: {
      get() {
        return this.getOptions.lineHeight || 20
      },
      set(newVal) {
        this.changeOptions(newVal, "lineHeight", false)
      }
    },
    lineHeightType: {
      get() {
        return this.getOptions.lineHeightType || "px"
      },
      set(newVal) {
        this.changeOptions(newVal, "lineHeightType", false)
      }
    },
    textDecoration: {
      get() {
        return this.getOptions.textDecoration || "none"
      },
      set(newVal) {
        this.changeOptions(newVal, "textDecoration", false)
      }
    },
    color: {
      get() {
        return this.getOptions.color || []
      },
      set(newVal) {
        this.changeOptions(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.getOptions.textIsThemeColor || false
      },
      set(newVal) {
        this.changeOptions(newVal, "textIsThemeColor", false)
      }
    },
    colorArr: {
      get() {
        return this.getOptions.colorArr || this.getOptions.color
      },
      set(val) {
        this.changeOptions(val, "colorArr", false)
      }
    },
    activeNameColor: {
      get() {
        return this.getOptions.activeNameColor || "first"
      },
      set(val) {
        this.changeOptions(val, "activeNameColor", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.getOptions.contentHasLimit
      },
      set(newVal) {
        this.changeOptions(newVal, "contentHasLimit", false)
      }
    },
    textLimitLines: {
      get() {
        return this.getOptions.textLimitLines
      },
      set(newVal) {
        this.changeOptions(newVal, "textLimitLines", false)
      }
    },
    textAlign: {
      get() {
        return this.getOptions.textAlign || 'center'
      },
      set(newVal) {
        this.changeOptions(newVal, "textAlign", false)
      }
    },
    activeArrangement() {
      return this.getOptions.textAlign
    },
    activeArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.writingMode = val
      }
    },
    writingMode: {
      get() {
        return this.getOptions.writingMode || "horizontal-tb"
      },
      set(newVal) {
        this.changeOptions(newVal, "writingMode", false)
      }
    },
    letterSpacing: {
      get() {
        return this.getOptions.letterSpacing || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "letterSpacing", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.getOptions.letterSpacingType || "px"
      },
      set(newVal) {
        this.changeOptions(newVal, "letterSpacingType", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.getOptions.bgColorIsThemeColor || false
      },
      set(newVal) {
        this.changeOptions(newVal, "bgColorIsThemeColor", false)
      }
    },
    bgColor: {
      get() {
        return this.getOptions.bgColor
      },
      set(newVal) {
        this.changeOptions(newVal, "bgColor", false)
      }
    },
    background: {
      get() {
        let background = this.getOptions.background
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.bgColorIsThemeColor,
            color: this.bgColor
          }
        ]
        this.changeOptions(newBackground, "background", false)
        return newBackground
      },
      set(newVal) {
        this.changeOptions(newVal, "background", false)
      }
    },
    iconPosition: {
      get() {
        return this.getOptions.iconPosition || "left"
      },
      set(newVal) {
        this.changeOptions(newVal, "iconPosition", false)
      }
    },
    showIcon: {
      get() {
        let showIcon = false
        if(this.getOptions.showIcon === undefined){
          if(this.getOptions.iconSrc){
            showIcon = true
          }else{
            showIcon = false
          }
        }else{
          showIcon = this.getOptions.showIcon
        }
        return showIcon
      },
      set(newVal) {
        this.changeOptions(newVal, "showIcon", false)
      }
    },
    iconSrc: {
      get() {
        return this.getOptions.iconSrc || ""
      },
      set(newVal) {
        this.changeOptions(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.getOptions.iconType || "icon"
      },
      set(newVal) {
        this.changeOptions(newVal, "iconType", false)
      }
    },
    iconWidth: {
      get() {
        return this.getOptions.iconWidth
      },
      set(newVal) {
        this.changeOptions(newVal, "iconWidth", false)
      }
    },
    iconMargin: {
      get() {
        return this.getOptions.iconMargin
      },
      set(newVal) {
        this.changeOptions(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.getOptions.iconColor || ""
      },
      set(newVal) {
        // console.log(newVal);
        this.changeOptions(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.getOptions.iconColorIsThemeColor || false
      },
      set(newVal) {
        this.changeOptions(newVal, "iconColorIsThemeColor", false)
      }
    },
    resInfo: {
      get() {
        return this.getOptions.resInfo || {}
      },
      set(newVal) {
        this.changeOptions(newVal, "resInfo", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.getOptions.borderTopLeftRadius || 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.getOptions.borderTopRightRadius || 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.getOptions.borderBottomRightRadius || 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.getOptions.borderBottomLeftRadius || 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.getOptions.borderBottomLeftRadius || 0)
      },
      set(newVal) {
        this.changeOptions(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.getOptions.borderStyle || "solid"
      },
      set(newVal) {
        this.changeOptions(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.getOptions.borderColor || ""
      },
      set(newVal) {
        this.changeOptions(newVal, "borderColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.getOptions.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.getOptions.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.changeOptions(newVal, "borderTypeFlag", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if(this.getOptions.showBorder === undefined){
          if(this.getOptions.borderWidth){
            showBorder = true
          }else{
            showBorder = false
          }
        }else{
          showBorder = this.getOptions.showBorder
        }
        
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.changeOptions([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.changeOptions(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "borderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.getOptions.borderIsThemeColor || false
      },
      set(newVal) {
        this.changeOptions(newVal, "borderIsThemeColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.getOptions.boxShadowColor || ""
      },
      set(newVal) {
        this.changeOptions(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.getOptions.boxShadowH || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.getOptions.boxShadowV || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.getOptions.boxShadowBlur || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.getOptions.boxShadowSpread || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "boxShadowSpread", false)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.getOptions.hasOwnProperty("paddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.getOptions.paddingTypeFlag || defaultType
      },
      set(newVal) {
        this.changeOptions(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.getOptions.padding || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.getOptions.paddingTop || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.getOptions.paddingRight || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.getOptions.paddingLeft || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.getOptions.paddingBottom || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "paddingBottom", false)
      }
    },
    opacity: {
      get() {
        return this.getOptions.hasOwnProperty("opacity") ? parseInt(this.getOptions.opacity * 100) : 100
      },
      set(newVal) {
        // 脏数据处理，不记录。opacity最大为1，历史数据有100的
        if (this.getOptions.opacity === 100) {
          this.changeOptions(newVal / 100, "opacity", false, false, false, true)
        } else {
          this.changeOptions(newVal / 100, "opacity", false)
        }
      }
    },
    cursorType: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "cursorType", "cursorType", '')
      },
      set(newVal) {
        this.changeOptions(newVal, "cursorType", false)
      }
    },
    content: {
      get() {
        let content = this.getOptions.content?.replace(/(<br>)*$/g, "") //替换末尾换行符
        return content
      },
      set(newVal) {
        newVal = String(newVal).replace(/<[^>]+>/g, "<br>")
        this.changeOptions(newVal, "content", false)
      }
    },
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })

  },
  methods: {
    changeOptions(newVal, name) {
      console.log('newVal :>>',newVal,name,this.options[this.buttonType]);
      if (!this.options[this.buttonType]) this.$changeOptionsEV({}, this.buttonType, false)
      if (Array.isArray(name) && name.length) {
        for (let i = 0; i < newVal.length; i++) {
          this.$changeOptionsEV(newVal[i], name[i], true, this.buttonType, this.ids)
        }
      } else {
        this.$changeOptionsEV(newVal, name, true, this.buttonType, this.ids)
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    widthTypeHandleCommand(val) {
      if (this.widthType === val) {
        return
      }
      this.widthType = val
      this.width = val === "%" ? 100 : 200
    },
    heightTypeHandleCommand(val) {
      if (this.heightType === val) {
        return
      }
      this.heightType = val
      this.height = val === "%" ? 100 : 200
    },
    addBoxshadow(prefix) {
      if (!Array.isArray(this[`${prefix}oxShadowH`])) {
        this[`${prefix}oxShadowH`] = [this[`${prefix}oxShadowH`]]
        this[`${prefix}oxShadowV`] = [this[`${prefix}oxShadowV`]]
        this[`${prefix}oxShadowBlur`] = [this[`${prefix}oxShadowBlur`]]
        this[`${prefix}oxShadowSpread`] = [this[`${prefix}oxShadowSpread`]]
        this[`${prefix}oxShadowColor`] = [this[`${prefix}oxShadowColor`]]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this[`${prefix}oxShadowH`]))
      let boxShadowV = JSON.parse(JSON.stringify(this[`${prefix}oxShadowV`]))
      let boxShadowBlur = JSON.parse(JSON.stringify(this[`${prefix}oxShadowBlur`]))
      let boxShadowSpread = JSON.parse(JSON.stringify(this[`${prefix}oxShadowSpread`]))
      let boxShadowColor = JSON.parse(JSON.stringify(this[`${prefix}oxShadowColor`]))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this[`${prefix}oxShadowH`] = boxShadowH
      this[`${prefix}oxShadowV`] = boxShadowV
      this[`${prefix}oxShadowBlur`] = boxShadowBlur
      this[`${prefix}oxShadowSpread`] = boxShadowSpread
      this[`${prefix}oxShadowColor`] = boxShadowColor
    },
    changeFilter(val, flag) {
      this.curFilter = val
      this.$emit("update:statusOpened", flag)
      this.$emit("update:styleOpened", !flag)
      this.$emit("onHideHeader", flag)
    },
    changeButtonFilter(val, flag) {
      this.changeFilter(0, false)
      this.buttonType = val
      this.$emit("update:statusOpened", flag)
      this.$emit("update:styleOpened", !flag)
      this.$emit("onHideHeader", flag)
    },
    changeRowLen(flag) {
      if (this.menuRowContent === 1 && flag === 0) {
        return
      }
      if (this.menuRowContent === 10 && flag === 1) {
        return
      }
      this.menuRowContent = flag === 0 ? this.menuRowContent - 1 : this.menuRowContent + 1
    },
    // 切换快捷定位的开关
    changeQuickSite() {
      this.isQuickSite = !this.isQuickSite
      this.margin = 0
      this.offset = 0
    },
  }
})
</script>

<style scoped lang="scss">
.custom-title-color {
  width: calc(100% - 76px);
}

.multiFilter-options-setting .width-type-tab ::v-deep .el-tabs .el-tabs__content {
  display: none;
}

.multiFilter-options-setting .width-type-tab ::v-deep .el-tabs .el-tabs__header {
  margin-left: 0;
  margin-right: 0;
}

.multiFilter-options-setting .tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}

.multiFilter-options-setting .tips-btn:hover {
  color: var(--themeColor);
}

::v-deep .explainDialog {
  width: 700px;
}

::v-deep .explainDialog .el-dialog__body {
  padding: 16px 24px 24px;
  color: var(--textColor);
}

::v-deep .explainDialog .tips span {
  font-weight: 600;
}

::v-deep .explainDialog .box {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  height: 366px;
  background: #fafafa;
  margin-top: 16px;
}

::v-deep .filter-state-set .el-tabs__content {
  padding-bottom: 0;
}

.navBox {
  height: 32px;
  padding: 4px 4px 4px 12px;
  border-radius: 4px;
  background: var(--inputBg);
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background: var(--inputNuberHoverThemeBgColor);
  }

  .navTitle {
    font-size: 13px;
    font-weight: 600;
    color: var(--textColor);
  }

  .navLabel {
    color: var(--thirdTextColor);
    display: flex;
  }

  .navIcon {
    font-size: 20px;
  }

  &:hover {
    cursor: pointer;
  }
}

.navBackBox {
  height: 38px;
  padding-left: 12px;
  display: flex;
  gap: 4px;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  .navBackIcon {
    font-size: 24px;
  }

  .navBackTitle {
    font-size: 14px;
    font-weight: 600;
    color: var(--textColor);
  }
}

.checked-label {
  padding: 8px 12px 16px 12px;
}

.option-choose-container {
  border-radius: 4px;
  padding: 5px 12px;
  background-color: var(--cardBgColor);
  border: 1px solid var(--sliderBackGround);
  margin-top: 8px;
}

.row-set {

  .btn-wrapper {
    flex: 1;
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;
    margin-left: 12px;

    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      cursor: pointer;
      color: var(--subTextColor);

      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }

      &:not(.disabled):hover {
        color: var(--themeColor);
      }

      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}
.padding12 {
  padding: 0px 12px 12px;
}
.edit-div {
  width: 100%;
  background-color: var(--inputBackGround);
  border: var(--inputBorder);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 4px;
}
.edit-div:focus {
  outline: none;
  border: 1px solid var(--themeColor);
}
.quick-set-switch {
  width: 32px;
  height: 32px;
  text-align: center;
  padding: 3px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 8px;
  background-color: #f3f3f3;
  color: var(--iconColor);
  cursor: pointer;
}

.quick-set-switch .item {
  display: inline-block;
  width: 100%;
  line-height: 26px;
  border-radius: 4px;
}

.quick-set-switch.open .item {
  color: var(--themeColor);
  background-color: #fff;
  border: 2px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
}

.quick-set-switch:hover {
  color: #000;
}
</style>
